import analyticsUtils from '../analytics-utils'

const productCategorySelect = (categoryId, categoryName) => {
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.PRODUCTS_CLICK,
    ecommerce: {
      click: {
        actionField: { list: 'Products Category' },
        products: [
          {
            id: categoryId,
            name: categoryName,
          },
        ],
      },
    },
  })

  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.SELECT_CATEGORY,
    eventCategory: analyticsUtils.categories.CATEGORY_SELECTION,
    eventAction: analyticsUtils.actions.SELECT_CATEGORY_FROM_HOMEPAGE,
    categoryT1: categoryName,
  })
}

export default productCategorySelect
